import api from '../api'
export default {
  namespaced: true,
  state: {
    hotelList: [],
    hotelTotal: '',
    hotelDetail: ''
  },
  mutations: {
    GET_HOTEL_LIST (state, data = {}) {
      state.hotelList = data.records || []
      state.hotelTotal = data.total
    },
    GET_HOTEL_DETAIL (state, data) {
      state.hotelDetail = data
    }
  },
  actions: {
    GET_HOTEL_LIST ({ commit, dispatch }, config) {
      return api.hotelList(config).then((res) => {
        commit('GET_HOTEL_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    GET_HOTEL_DETAIL ({ commit, dispatch }, config) {
      return api.hotelDetail(config).then((res) => {
        commit('GET_HOTEL_DETAIL', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_HOTEL ({ commit, dispatch }, params) {
      return api.deletehotel({
        params: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    ADD_HOTEL ({ commit, dispatch }, config) {
      return api.addhotel(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    UPDATE_HOTEL ({ commit, dispatch }, config) {
      return api.updatehotel(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/hotelManage/store/index.js